import React, { useState, useEffect, useRef, useContext } from 'react'
import { Popover, Button, makeStyles, Radio, Badge, FormControlLabel, FormControl, CircularProgress, useMediaQuery, IconButton, Checkbox, FormGroup } from "@material-ui/core";
//import { useNotify } from "react-admin";
import config from '../config.json';
import { stringify } from 'query-string';
import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@material-ui/icons/Search';
import FilterListIcon from '@material-ui/icons/FilterList';
import { customTheme } from "../customTheme";
import { ContextProvider } from '../globalContextProvider';
import { saveTokens } from '../utils/saveTokens';
import FilterIcon from "../images/filterIcon.svg";
import notify from './CustomUseNotify';



const ListItemScroll = (props) => {

    let { resultList, indexChange, radioValue, radioHandleChange, setParamsInc, searchText, loading, noRecords, listInnerRef } = props
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));

    const onScroll = () => {
        if (searchText.length === 0) {
            if (listInnerRef.current) {
                const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
                if (scrollTop + clientHeight === scrollHeight) {
                    setParamsInc(prev => prev + 1)
                }
            }
        }
    };

    let filteredList
    let responseSource = resultList[indexChange].responseSource

    if (responseSource === "operator") {
        filteredList = searchText !== "" ? resultList[indexChange].dataList.filter(val => val.operator.toLowerCase().includes(searchText.toLowerCase())) : resultList[indexChange].dataList;

    } else if (responseSource === "serial_number") {
        filteredList = searchText !== "" ? resultList[indexChange].dataList.filter(val => val.serial_number.toLowerCase().includes(searchText.toLowerCase())) : resultList[indexChange].dataList;

    } else {
        filteredList = searchText !== "" ? resultList[indexChange].dataList.filter(val => val.name.toLowerCase().includes(searchText.toLowerCase())) : resultList[indexChange].dataList;

    }

    return (
        <div style={{ height: isSmallDevice ? "100%" : "100%", overflow: "hidden", marginTop: isSmallDevice ? "25px" : "0px" }}>
            {noRecords && <p className='noRecords'>No results found for <span style={{ fontWeight: "bold" }}>{searchText}</span></p>}
            <div onScroll={onScroll} ref={listInnerRef} style={{ overflow: "auto", overflowX: "hidden", height: "90%" }}>

                {
                    searchText.length >= 1 && resultList[indexChange].listType === "Dynamic" ? <FormControl component="fieldset" variant="standard">
                        {

                            resultList[indexChange].searchList.map((list) => {
                                return (
                                    <FormGroup aria-label="gender"
                                        name="controlled-radio-buttons-group"
                                        value={radioValue[indexChange].value}
                                        onChange={(e) => radioHandleChange(e, list)}
                                        style={{ marginTop: isSmallDevice ? "8px" : "0px" }}
                                    >
                                        <FormControlLabel size="small" value={list.general_name ? list.general_name : list.name ? list.name : list.serial_number ? list.serial_number : list.operator} control={resultList[indexChange].filterType === "Parking Name" && resultList[indexChange].filterFormat === "Checkbox" ? <Checkbox size='small' /> : <Radio />} label={list.general_name ? list.general_name : list.name ? list.name : list.serial_number ? list.serial_number : list.operator} />
                                    </FormGroup>
                                )
                            })
                        }
                    </FormControl> : <FormControl component="fieldset" variant="standard">
                        {filteredList.map((list) => {
                            return (
                                <FormGroup aria-label="gender"
                                    name="controlled-radio-buttons-group"
                                    value={radioValue[indexChange].value}
                                    onChange={(e) => radioHandleChange(e, list)}
                                    style={{ marginTop: isSmallDevice ? "8px" : "0px" }}
                                >
                                    <FormControlLabel value={list.general_name ? list.general_name : list.name ? list.name : list.serial_number ? list.serial_number : list.operator} control={resultList[indexChange].filterType === "Parking Name" && resultList[indexChange].filterFormat === "Checkbox" ? <Checkbox size='small' /> : <Radio />} label={list.general_name ? list.general_name : list.name ? list.name : list.serial_number ? list.serial_number : list.operator} />
                                </FormGroup>

                            )
                        })}
                        {filteredList.length === 0 && resultList[indexChange].caseType === "Static" && <p className='noRecords'>No results found for <span style={{ fontWeight: "bold" }}>{searchText}</span></p>}
                        {filteredList.length === 0 && resultList[indexChange].caseType === "Zones" && <p className='noRecords'>Please select <span style={{ fontWeight: "bold" }}>Parking Name.</span></p>}
                        {filteredList.length === 0 && resultList[indexChange].listType === "Dynamic" && <p className='noRecords'>No records found.</p>}

                    </FormControl>
                }

                {loading && <CircularProgress className="circularProgress" />}
            </div>
        </div>
    )
}

export default function CustomFilterCheckBox(props) {
    const { filterTypesInitState, filterListValue, setFilterListValue, accessKeyId, setCurrentParking, currentParkingFlag, pathName } = props;
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const { setIsChange } = useContext(ContextProvider);
    const useStyles = makeStyles({
        root: {
            height: isSmallDevice ? "40px" : "auto",
            width: isSmallDevice ? "200px" : "100px"
        },
        muiPopoverPaper: {
            minWidth: "380px",
            width: !isSmallDevice ? "40%" : "none",
            position: isSmallDevice ? "static" : "absolute",
            border: "1px #E0E5EC solid",
            height: isSmallDevice ? "100vh" : "440px",
            maxWidth: "none",
            maxHeight: "none",
            fontFamily: "Poppins-Medium",
            backgroundColor: "#F5F8FA"
        }
    });
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [searchText, setSearchText] = useState("");
    const listInnerRef = useRef();

    //filtering the List on the basis of conditions
    let stateAfterFilter = filterTypesInitState.filter((val) => val.showFilter)
    const [resultList, setResultList] = useState(stateAfterFilter);
    // making list for List values using resultList
    let filterListValueOfResultList = resultList.map((val) => {
        return { filterType: val.filterType, value: "", id: "" }
    })

    const [indexChange, setIndexChange] = useState(0);
    const [paramsInc, setParamsInc] = useState(1)
    const [radioValue, setRadioValue] = useState([...filterListValueOfResultList])
    console.log(radioValue)
    //const notify = useNotify();
    const fetchParkingTimeout = useRef(null);
    const [loading, setLoading] = useState(false)
    const [noRecords, setNoRecords] = useState(false)
    const [reset, setRest] = useState(false)
    const [didMount, setDidMount] = useState(false)
    //console.log(resultList)
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        setIsChange(false)
        if (filterListValue) {
            setRadioValue([...filterListValue])
        }
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;


    const fetchParkings = () => {
        const token = sessionStorage.getItem('token');

        if (resultList[indexChange].listType === "Dynamic") {
            if (token != null && token !== "") {
                setLoading(true)
                var params = {
                    user_id: sessionStorage.getItem("user_id"),
                    filter: JSON.stringify({ [resultList[indexChange].resourceParam ? resultList[indexChange].resourceParam : resultList[indexChange].source]: searchText }),
                    sort: JSON.stringify(["name", "ASC"]),
                    page: searchText.length >= 1 ? 1 : paramsInc,
                    perPage: 15
                }
                fetch(`${config.HOST_NAME}/crm/v3/${resultList[indexChange].resourcePath}?${stringify(params)}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                        'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                    },
                })
                    .then(response => {
                        saveTokens(response)
                        return response.json()
                    })
                    .then((responseJson) => {
                        if (responseJson.success) {

                            if (reset) {
                                //console.log("rest block")
                                setResultList(resultList => {
                                    const copy = [...resultList]
                                    copy[indexChange].dataList = responseJson.data
                                    return copy
                                })
                                setRest(false)
                                setLoading(false)
                                return
                            } else if (searchText.length >= 1 && resultList[indexChange].listType === "Dynamic") {
                                if (responseJson.data.length === 0) {
                                    setNoRecords(true);
                                } else {
                                    setNoRecords(false);
                                }
                                setResultList(resultList => {
                                    const copy = [...resultList]
                                    copy[indexChange].searchList = responseJson.data
                                    return copy
                                })
                                setLoading(false)
                                return
                            } else if (searchText.length === 0) {
                                //console.log("no block")
                                setResultList(resultList => {
                                    const copy = [...resultList]

                                    if (copy[indexChange].searchList.length !== 0) {
                                        copy[indexChange].dataList = [...responseJson.data]
                                        return copy
                                    }
                                    copy[indexChange].dataList = [...copy[indexChange].dataList, ...responseJson.data]
                                    return copy
                                })
                                setNoRecords(false)
                                setLoading(false)
                            }

                        } else {
                            notify(responseJson.message, 'warning');
                        }
                    })
                    .catch((e) => {
                        setLoading(false)
                        notify('Error fetching data', 'warning');
                        console.log(e);
                    });
            }
        }
    };

    const onChangeHandler = (index) => {
        setIndexChange(index)
        setSearchText("")
        setNoRecords(false)
        scrollToTop()
    }

    const radioHandleChange = (e, list) => {

        if (resultList[indexChange].filterType === "Parking Name" && resultList[indexChange].filterFormat === "Checkbox") {

            setRadioValue(radioValue => {
                let copy = [...radioValue]
                let copyItem = { ...copy[indexChange] };
                copyItem.value = [...copyItem.value, e.target.value]
                copyItem.id = [...copyItem.id, list.id]
                copy[indexChange] = copyItem
                return copy
            });

        } else {
            setRadioValue(radioValue => {
                let copy = [...radioValue]
                let copyItem = { ...copy[indexChange] };
                copyItem.value = e.target.value
                copyItem.id = list.id
                copy[indexChange] = copyItem
                return copy
            });
        }


        if (resultList[indexChange].filterType === "Parking Name") {

            let currentParking = list
            // console.log(currentParking);
            //Only for Zones
            const zoneIds = currentParking.zone_ids ? currentParking.zone_ids.split(",") : null;
            const zoneLabels = currentParking.zones ? currentParking.zones.split(";") : null;
            const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
                { id, name: zoneLabels[index] }
            )) : null;
            if (finalZones)
                finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));

            setResultList(resultList => {
                const copy = [...resultList]
                copy[indexChange + 1].dataList = [...copy[indexChange + 1].dataList, ...finalZones]
                return copy
            })
        }
    };

    const searchHandleChange = (event) => {
        setSearchText(event.target.value)
    };

    const filterRequest = () => {
        //setFilterList(radioValue)

        if (sessionStorage.getItem(pathName)) {
            let prevdata = JSON.parse(sessionStorage.getItem(pathName))
            sessionStorage.setItem(`${pathName}`, JSON.stringify({ ...prevdata, radioValue: radioValue }))
        } else {
            sessionStorage.setItem(`${pathName}`, JSON.stringify({ radioValue: radioValue }))
        }
        setFilterListValue(radioValue)
        setIsChange(true)
        if (currentParkingFlag) {
            setCurrentParking(null)
        }

        handleClose()
    };

    const scrollToTop = () => {
        listInnerRef.current.scrollTop = 0
    }

    const resetHandler = () => {
        setFilterListValue(null)
        setRest(true)
        setRadioValue(filterListValueOfResultList)
        setParamsInc(1)
        setIndexChange(0)
        scrollToTop()
    }

    useEffect(() => {
        if (fetchParkingTimeout.current)
            clearTimeout(fetchParkingTimeout.current);
        fetchParkingTimeout.current = setTimeout(fetchParkings, 800);
    }, [searchText, accessKeyId, paramsInc]);  // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => { setDidMount(true) }, [])

    useEffect(() => {

        if (didMount) {
            if (resultList[indexChange].dataList.length === 0) {

                fetchParkings()
            }
        }
    }, [indexChange])  // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div style={{ display: "flex", justifyContent: "start", alignItems: "start", columnGap: 30 }}>
            {
                !isSmallDevice && <Button className="customStyleBtn" style={{ marginRight: "10px", height: "31px" }} variant="outlined" aria-describedby={id} color="primary" disableElevation size='small' onClick={handleClick}>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <img src={FilterIcon} alt="Filter Icon" width={20} height={20} style={{ marginRight: 10 }} />
                        <p>Filter</p>
                        {
                            filterListValue && filterListValue.filter((selectedFilter) => selectedFilter.id !== "").length > 0 &&
                            <div style={{ display: "fex", justifyContent: "center", alignItems: 'center', borderRadius: 20, color: "#fff", backgroundColor: "#334d6e", height: 18, width: 18, marginLeft: 10 }}>
                                <p style={{ lineHeight: "0px", marginTop: 10, fontSize: 12 }}>{filterListValue ? filterListValue.filter((selectedFilter) => selectedFilter.id !== "").length : 0}</p>
                            </div>
                        }
                    </div>
                </Button>
            }
            {
                isSmallDevice && <IconButton className="customStyleBtn customStyleBtnSmallScreen" onClick={handleClick} aria-label="delete" style={{ marginRight: "10px" }} >
                    <Badge badgeContent={filterListValue ? filterListValue.filter((selectedFilter) => selectedFilter.id !== "").length : 0} invisible={filterListValue && filterListValue.filter((selectedFilter) => selectedFilter.id !== "").length > 0 ? false : true}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                        color="secondary">
                        <img src={FilterIcon} alt="Filter Icon" width={22} height={22} />
                    </Badge>
                </IconButton>
            }
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                elevation={2}
                classes={{
                    paper: classes.muiPopoverPaper
                }}

            >
                <div style={{ width: "auto", display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px #E0E5EC solid", padding: isSmallDevice ? "10px 20px" : "0px 20px", backgroundColor: "#F5F8FA" }}>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", columnGap: 10 }}>
                        <FilterListIcon style={{ fill: "#18cc69" }} />
                        <p>Filter by</p>
                    </div>
                    <CloseIcon style={{ cursor: "pointer", fill: "#18cc69" }} onClick={() => handleClose()} />
                </div>
                <div style={{ display: "flex", height: isSmallDevice ? "77%" : "74%", }}>
                    <div className='filterTypeContainer' style={{ backgroundColor: "#F5F8FA", borderRight: "1px #E0E5EC solid", fontSize: 12, width: isSmallDevice ? "60%" : "40%" }}>

                        {
                            resultList.map((list, index) => {
                                return <div className={index === indexChange ? "filterTypeActive" : "filterType"} style={{ padding: "2px 10px", cursor: "pointer" }} onClick={() => onChangeHandler(index)}>
                                    <p >{list.filterType}</p>
                                </div>
                            })
                        }
                    </div>
                    <div className='filterSearchContainer' style={{ padding: "20px 20px", width: "100%", backgroundColor: "#fff" }}>
                        <div className='inputFilterContainer' style={{ marginBottom: "10px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <SearchIcon style={{ fill: "#18cc69" }} />
                            <input className='inputFilter'
                                type="text"
                                value={searchText}
                                onChange={searchHandleChange}
                                placeholder='Search'
                                disabled={resultList[indexChange].dataList.length === 0 ? true : false}
                            />

                        </div>

                        <ListItemScroll resultList={resultList} indexChange={indexChange} radioValue={radioValue} radioHandleChange={radioHandleChange} fetchParkings={fetchParkings} setParamsInc={setParamsInc} searchText={searchText} loading={loading} paramsInc={paramsInc} noRecords={noRecords} listInnerRef={listInnerRef} />
                    </div>
                </div>
                <div style={{ width: "auto", display: "flex", justifyContent: "flex-end", alignItems: "center", columnGap: 20, borderTop: "1px #E0E5EC solid", padding: isSmallDevice ? "0px 20px" : "12px 20px", height: isSmallDevice ? "12%" : "auto", backgroundColor: "#F5F8FA", minHeight: isSmallDevice ? "84px" : "none" }}>
                    <Button size='small' className={classes.root} color='primary' variant="outlined" disableElevation onClick={resetHandler}>
                        Reset
                    </Button>
                    <Button size='small' className={classes.root} color='primary' variant="contained" disableElevation onClick={filterRequest}>
                        Apply
                    </Button>
                </div>
            </Popover >
        </div >
    );
}


